import { Box, Container, Typography, Link, Grid, IconButton } from '@mui/material';
import { Facebook, LinkedIn, Twitter } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 6,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="space-between">
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              GrowTaxBusiness.com
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Helping tax professionals build successful businesses
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Legal
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Link
                component={RouterLink}
                to="/privacy-policy"
                color="text.secondary"
                sx={{ mb: 1, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
              >
                Privacy Policy
              </Link>
              <Link
                component={RouterLink}
                to="/terms-and-conditions"
                color="text.secondary"
                sx={{ mb: 1, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
              >
                Terms & Conditions
              </Link>
            </Box>
          </Grid>
        </Grid>
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ mt: 4 }}
        >
          {new Date().getFullYear()} GrowTaxBusiness.com. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
